<template>
    <div class="AccountCenterWarp">
        <!-- <el-row> -->
        <el-row>
            <el-col :span="24">
                <div class="accountHeaderBox" style="height:97px">
                    <div class="logoimg">
                        <img src='@/assets/imgs/home/logo.png' />
                    </div>
                    <div class="headerRight">
                        <!-- <div>
                        <el-badge :value="infoListData.length" class="item">
                            <i class="el-icon-bell icon" />
                        </el-badge>
                    </div> -->
                        <img :src='srcUrl+auditObj.logo' v-if="auditObj.logo" class="headerImg" />
                        <img :src='headImgUrl' v-else class="headerImg" />
                        <!-- <div v-if="auditObj">
                        {{auditObj.userName}}
                    </div> -->
                        <div class="userNameBox">
                            <!-- v-model="visible" -->
                            <el-popover placement="bottom" style="marginTop:72px" width="136" trigger="click" popper-class='mypopover'>
                                <div class="handlebox">
                                    <div class="editpwd" style="textaling:center" @click="editphoneFn">修改手机号</div>
                                    <div class="editpwd" style="textaling:center" @click="editpwdFn">修改密码</div>
                                    <!-- <div class="editpwd" style="textaling:center" @click="bindWechartFn">{{isBind?'微信解绑':'微信绑定'}}</div> -->
                                    <!-- <div class="editpwd" style="textaling:center" @click="bindWechartFn" v-if="!isBind">微信绑定</div> -->
                                    <div class="outlogin" @click="outloginFn">退出登录</div>
                                </div>
                                <el-button v-if="auditObj" slot="reference">{{auditObj.userName}}</el-button>
                                <!-- @click="visible = !visible" -->
                            </el-popover>
                        </div>
                    </div>
                    <!-- <div class="headerRight" v-else>
                        <div>登录</div>
                    </div> -->
                </div>
            </el-col>
        </el-row>
        <el-row>
            <div class="centerbox">
                <el-row>
                    <el-col :span="4">
                        <div class="menuwarp" style="width:100%">
                            <div v-for="(item,index) in menuList" :key="index" :class="activeName==item.name?'activemenuitembox':'menuitembox'" @click="changeMenuFn(item)">
                                <img :src="activeName==item.name?item.activeicon:item.icon" class="imgbox" />
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="20">
                        <div :class="activeName=='账户中心'||activeName=='信息发布管理'?'centerMainBox2':'centerMainBox'">
                            <router-view />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-row>
        <el-dialog :visible.sync="codeVisible" width="480px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'
            :close="offloginVisible">
            <div class="codeBox" v-if="!isBind">
                <div id="wxcode">
                </div>
            </div>
            <div v-else class="bindBox">
                <div class="text1">是否确定解除微信绑定?</div>
                <div class="btnbox">
                    <el-button type="primary" @click="bindBtnFn">确定</el-button>
                    <el-button @click="offloginVisible">取消</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- </el-row> -->
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import AccountcenterPage from './components/accountcenterPage'
import AccountInfoManagement from './components/accountInfoManagement'
import TrainingCourseManagement from './components/TrainingCourseManagement/trainingCourseManagement'
import MembershipDues from './components/MembershipDues'
import InformationReleaseManagement from './components/InformationReleaseManagement/informationReleaseManagement.vue'
import AddInfoNews from './components/AddInfoNews'
export default {
    components: {
        AccountcenterPage,
        AccountInfoManagement,
        TrainingCourseManagement,
        MembershipDues,
        InformationReleaseManagement,
        AddInfoNews
    },
    data() {
        return {
            srcUrl: srcUrl,
            headImgUrl: require("@/assets/imgs/account/header.png"),
            menuList: [
                { name: '账户中心', activeicon: require("@/assets/imgs/account/activeicon1.png"), icon: require("@/assets/imgs/account/icon1.png"), url: '/account-center/centerpage' },
                { name: '账户信息管理', activeicon: require("@/assets/imgs/account/activeicon2.png"), icon: require("@/assets/imgs/account/icon2.png"), url: '/account-center/account-info' },
                { name: '培训课程管理', activeicon: require("@/assets/imgs/account/activeicon3.png"), icon: require("@/assets/imgs/account/icon3.png"), url: '/account-center/train-course' },
                { name: '专家库申请发布', activeicon: require("@/assets/imgs/account/activeicon7.png"), icon: require("@/assets/imgs/account/icon12.png"), url: '/account-center/expert-database' },
                { name: '返回网站首页', activeicon: require("@/assets/imgs/account/activeicon6.png"), icon: require("@/assets/imgs/account/icon6.png"), url: '/' },
            ],
            activeName: '账户中心',
            isaddNews: '列表',
            islogin: sessionStorage.getItem('token'),
            userId: '',
            auditObj: {},
            visible: false,
            infoListData: [],
            isBind: false,
            codeVisible: false,
        }
    },
    created() {
        if (JSON.parse(sessionStorage.getItem('userInfo'))) {
            this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
        } else {
            this.userId = sessionStorage.getItem('nologinuserId')
        }
        // 会员状态
        if (this.islogin) {
            this.getAuditFn()
        }
        this.getinfofn()
        // 判断是否绑定微信
        this.bindWechat()

    },
    mounted() {
        this.createWxQrcode()
        if (this.$route.query.state) {
            this.userbindWechart(this.$route.query.code, this.$route.query.state)
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                if (val.meta.title == '新增信息发布' || val.meta.title == '预览信息') {
                    this.activeName = '信息发布管理'
                } else if (val.meta.title == '申请入会') {
                    this.activeName = '账户中心'
                }
                else if (val.meta.title == '领军人才报名详情' || val.meta.title == '课程报名详情') {
                    this.activeName = '培训课程管理'
                }

                else {
                    this.activeName = val.meta.title
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        getAuditFn() {
            httpService.getCorpInfoOther(this.userId).then(res => {
                // 99保存 0提交审核中 1通过 2审核失败
                if (res.code == 200) {
                    this.auditObj = res.result
                    if (res.result.audit == 1) {
                        if (res.result.memberStatus == 2) {
                            this.menuList = [
                                { name: '账户中心', activeicon: require("@/assets/imgs/account/activeicon1.png"), icon: require("@/assets/imgs/account/icon1.png"), url: '/account-center/centerpage' },
                                { name: '账户信息管理', activeicon: require("@/assets/imgs/account/activeicon2.png"), icon: require("@/assets/imgs/account/icon2.png"), url: '/account-center/account-info' },
                                { name: '培训课程管理', activeicon: require("@/assets/imgs/account/activeicon3.png"), icon: require("@/assets/imgs/account/icon3.png"), url: '/account-center/train-course' },
                                { name: '会费缴纳', activeicon: require("@/assets/imgs/account/activeicon4.png"), icon: require("@/assets/imgs/account/icon4.png"), url: '/account-center/membership-duse' },
                                { name: '专家库申请发布', activeicon: require("@/assets/imgs/account/activeicon7.png"), icon: require("@/assets/imgs/account/icon12.png"), url: '/account-center/expert-database' },
                                { name: '返回网站首页', activeicon: require("@/assets/imgs/account/activeicon6.png"), icon: require("@/assets/imgs/account/icon6.png"), url: '/' },
                            ]
                        } else {
                            this.menuList = [
                                { name: '账户中心', activeicon: require("@/assets/imgs/account/activeicon1.png"), icon: require("@/assets/imgs/account/icon1.png"), url: '/account-center/centerpage' },
                                { name: '账户信息管理', activeicon: require("@/assets/imgs/account/activeicon2.png"), icon: require("@/assets/imgs/account/icon2.png"), url: '/account-center/account-info' },
                                { name: '培训课程管理', activeicon: require("@/assets/imgs/account/activeicon3.png"), icon: require("@/assets/imgs/account/icon3.png"), url: '/account-center/train-course' },
                                { name: '会费缴纳', activeicon: require("@/assets/imgs/account/activeicon4.png"), icon: require("@/assets/imgs/account/icon4.png"), url: '/account-center/membership-duse' },
                                { name: '信息发布管理', activeicon: require("@/assets/imgs/account/activeicon5.png"), icon: require("@/assets/imgs/account/icon5.png"), url: '/account-center/info-release' },
                                { name: '专家库申请发布', activeicon: require("@/assets/imgs/account/activeicon7.png"), icon: require("@/assets/imgs/account/icon12.png"), url: '/account-center/expert-database' },
                                { name: '返回网站首页', activeicon: require("@/assets/imgs/account/activeicon6.png"), icon: require("@/assets/imgs/account/icon6.png"), url: '/' },
                            ]
                        }

                    } else {
                        this.menuList = [
                            { name: '账户中心', activeicon: require("@/assets/imgs/account/activeicon1.png"), icon: require("@/assets/imgs/account/icon1.png"), url: '/account-center/centerpage' },
                            { name: '账户信息管理', activeicon: require("@/assets/imgs/account/activeicon2.png"), icon: require("@/assets/imgs/account/icon2.png"), url: '/account-center/account-info' },
                            { name: '培训课程管理', activeicon: require("@/assets/imgs/account/activeicon3.png"), icon: require("@/assets/imgs/account/icon3.png"), url: '/account-center/train-course' },
                            { name: '专家库申请发布', activeicon: require("@/assets/imgs/account/activeicon7.png"), icon: require("@/assets/imgs/account/icon12.png"), url: '/account-center/expert-database' },
                            { name: '返回网站首页', activeicon: require("@/assets/imgs/account/activeicon6.png"), icon: require("@/assets/imgs/account/icon6.png"), url: '/' },
                        ]
                    }
                }
            })
        },
        async getinfofn() {
            let params = {
                pageSize: 10,
                pageCurrent: 1,
            };
            let data = await httpService.NotificationList(params);
            if (data.code == 200) {
                this.infoListData = data.result.list
            }
        },
        changeMenuFn(item) {
            if (item.name == '返回网站首页') {
                this.$router.push(item.url);
                sessionStorage.setItem('clickMenu', '首页')
            } else {
                if (this.islogin) {
                    this.activeName = item.name
                    this.$router.push(item.url);
                } else {
                    this.$message({
                        message: '请先登录网站',
                        type: 'warning'
                    });
                }
            }
        },
        // // 新增新闻发布
        // addNewsFn(data, data2) {
        //     this.isaddNews = data
        //     // data2是传给新增组件的修改值
        // },
        // offAddNewsFn(data) {
        //     this.isaddNews = data
        // }
        editpwdFn() {
            // sessionStorage.clear()
            this.$router.push({
                path: '/retrieve-password',
                query: {
                    name: '修改密码'
                }
            })
        },
        editphoneFn() {
            this.$router.push({
                path: '/retrieve-phone',
                // query: {
                //     name: '修改密码'
                // }
            })
        },
        outloginFn() {
            sessionStorage.clear()
            this.$message({
                message: '退出登录成功',
                type: 'success'
            });
            this.$router.push('/');
            sessionStorage.setItem('clickMenu', '首页')
        },
        createWxQrcode() {
            // 生成微信登录二维码
            var obj = new WxLogin({
                self_redirect: false,
                id: "wxcode", // 页面显示二维码的容器id
                appid: "wx0ca107b920ae43d4", // 微信官方提供的测试id
                scope: "snsapi_login",
                redirect_uri: encodeURI("http://www.zgrcjlxh.com/account-center/centerpage"), // 微信官方中的测试地址
                state: this.userId,
                style: "black",
                href: "",
            });
        },
        bindWechat() {
            httpService.isWeChatBinding(this.userId).then(res => {
                if (res.code == 200) {
                    this.isBind = res.result
                }
            })
        },
        bindWechartFn() {
            if (this.isBind) {

                this.codeVisible = true
            } else {
                this.codeVisible = true
                this.$nextTick(function () {
                    this.createWxQrcode()
                })
            }
        },
        offloginVisible() {
            this.codeVisible = false
        },
        bindBtnFn() {

            httpService.weChatNnbundle(this.userId).then(res => {
                if (res.code == 200) {
                    this.$message.success('解绑成功')
                    this.codeVisible = false
                    this.bindWechat()
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        userbindWechart(code, state) {
            httpService.weChatBindingUser(code, state).then(res => {
                if (res.code == 200) {
                    this.$router.push('/account-center/centerpage');
                    this.$router.go(0)
                    // 判断微信登录是否修改用户名
                    this.bindWechat()

                } else {
                    this.$message.error(res.message);
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.AccountCenterWarp {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0 auto;
  // overflow: hidden;
  overflow-y: hidden;
  position: relative;
  // .el-container {
  // 	display: flex;
  // 	flex-direction: column;
  // }
  .accountHeaderBox {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 97px;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.08);
    padding: 15px 0;
    box-sizing: border-box;
    .logoimg {
      width: 494px;
      height: 68px;
      padding-left: 24px;
    }
    .headerRight {
      height: 97px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 64px;
      .icon {
        font-size: 22px;
      }
      .headerImg {
        margin: 0 20px 0 24px;
        height: 54px;
        width: 54px;
        border-radius: 50%;
      }
      .userNameBox {
        font-size: 15px;
        font-weight: 500;
        color: #43424b;
        /deep/.el-popover {
          text-align: center;
          font-size: 18px;
          line-height: 36px;
        }
        /deep/.el-popper {
          margin-top: 72px;
        }
        /deep/.handlebox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          cursor: pointer;
          padding: 12px 0;
          .editpwd,
          .outlogin {
            font-size: 21px;
            line-height: 40px;
            color: #43424b;
            cursor: pointer;
            text-align: center;
          }
          div:hover {
            font-size: 21px;
            font-weight: 400;
            line-height: 40px;
            color: #0083ff;
            cursor: pointer;
            text-align: center;
          }
        }
        /deep/.el-button {
          border: none;
          padding: 0;
          font-size: 16px;
        }
      }
    }
  }
  .centerbox {
    width: 100%;
    height: 90vh;
    box-sizing: border-box;
    position: relative;
  }
  .menuwarp {
    width: 100%;
    padding: 53px 0 0 15px;
    box-sizing: border-box;
    border-right: 1px solid #e8e8e8;
    height: 100vh;
    // position: fixed;
    .activemenuitembox {
      width: 97%;
      height: 48px;
      background: #f5f6fa;
      border-radius: 28px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      .imgbox {
        margin: 0 12px 0 24px;
      }
    }
    .menuitembox {
      width: 97%;
      height: 48px;
      margin-bottom: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;
      .imgbox {
        margin: 0 24px 0 30px;
      }
    }
  }
  .centerMainBox {
    // width: 1620px;
    width: 100%;
    // overflow-y: scroll!important;
    padding: 33px 0 20px 15px;
    box-sizing: border-box;
    // min-height: 100vh;
    // height: 1024px;
    height: 90vh;
    // overflow-x: hidden;
    overflow-y: scroll;
  }
  .centerMainBox2 {
    width: 100%;
    // overflow-y: scroll!important;
    padding: 33px 0 20px 15px;
    box-sizing: border-box;
    // min-height: 100vh;
    // height: 1024px;
    height: 88vh;
    overflow: auto;
    // overflow-x: hidden;
    // overflow-y: hidden;
  }
}
</style>

// <style lang="less">
// .mypopover {
//     margin-top: 72px;
// 	/deep/.el-popper {
// 		margin-top: 72px;
// 	}
// 	/deep/.handlebox {
// 		display: flex;
// 		flex-direction: column;
// 		justify-content: center;
// 		cursor: pointer;
// 		padding: 10px 0;
// 		.editpwd,
// 		.outlogin {
// 			font-size: 18px;
// 			line-height: 40px;
// 			color: #43424b;
// 			cursor: pointer;
// 			text-align: center;
// 		}
// 		div:hover {
// 			font-size: 18px;
// 			font-weight: 400;
// 			line-height: 40px;
// 			color: #0083ff;
// 			cursor: pointer;
// 			text-align: center;
// 		}
// 	}
// }
//
.dialogWarp {
  /deep/.codeBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  /deep/.bindBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .text1 {
      text-align: center;
      font-size: 19px;
      font-weight: 500;
    }
    .btnbox {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>

